import { render } from "./VerificationHeader.vue?vue&type=template&id=2d9854ff&scoped=true"
import script from "./VerificationHeader.vue?vue&type=script&lang=js"
export * from "./VerificationHeader.vue?vue&type=script&lang=js"

import "./VerificationHeader.vue?vue&type=style&index=0&id=2d9854ff&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9854ff"]])